export default __webpack_public_path__ + "static/media/logout.6e4a0140.svg";